import { faTimes } from '@fortawesome/pro-light-svg-icons'
import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import Grid from '@material-ui/core/Grid'
import { useRouter } from 'next/router'
import React, { PropsWithChildren, useMemo } from 'react'
import { MobileSearchBar } from './MobileSearchBar'
import { StyledSearchIcon, StyledSearchIconContainer } from './StyledSearchBarIcon'

export type SearchBarProps = React.ComponentProps<typeof Grid> & {
  onChange?: (event: React.FormEvent) => void
  onToggle: () => void
  focus: boolean
  inputRef: React.MutableRefObject<HTMLInputElement>
  sticky?: boolean
  secondary?: boolean
}

export const MobileSearchBarContainer: React.FC<PropsWithChildren<SearchBarProps>> = ( props ) => {
  const [openSearch, setOpen] = React.useState(false)
  const router = useRouter()
  const isOpen = useMemo(() => {
    if (router?.route === '/search') {
      return true
    }

    return openSearch
  }, [openSearch, router])

  const setOpenSearch = () => {
    if (openSearch) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }

  const unfocus = () => {
    setOpen(false)
  }

  return(
    <React.Fragment>
      {router?.route === '/search' ? null:
        <StyledSearchIconContainer aria-label="search" onClick={setOpenSearch}>
          <StyledSearchIcon icon={isOpen ? faTimes : faSearch}  />
        </StyledSearchIconContainer>
      }
      {isOpen &&
        <MobileSearchBar {...props} isOpen={isOpen} unfocus={unfocus} />
      }
    </React.Fragment>
  )
}